import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import type { BillingFeature } from 'webapp/enums/enums';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type { TrackingOriginTypeForTrialPopupOpened } from 'webapp/services/billing';

interface Args {
	billingFeature: BillingFeature; // see fragment.disabledLimitation
	trackingOrigin?: TrackingOriginTypeForTrialPopupOpened;
}

export default class ReportsDisabledOverlayComponent extends Component<Args> {
	@service('billing') declare billingService: Service.Billing;
	@service('navigation') declare navigationService: Service.Navigation;

	get feature() {
		return this.args.billingFeature;
	}

	get isClickable() {
		return (
			!this.navigationService.isDatawallApp && !this.navigationService.isLoadedFromSnapshooter
		);
	}

	@action
	handleClick() {
		if (!this.isClickable) {
			return;
		}
		this.billingService.handleLimitations(this.args.billingFeature, this.args.trackingOrigin);
	}
	<template>
		<div
			class="disabled-overlay disabled-overlay-reports {{if this.isClickable 'clickable'}}"
			role="button"
			{{on "click" this.handleClick}}
		>
			<CommonUiIconComponent @name="Lock" @size="lg" />
		</div>
	</template>
}
